import { useTheme, useMediaQuery } from '@mui/material';
import TicketDetailPageDesktop from './TicketDetailPageDesktop';
import TicketDetailPageMobile from './TicketDetailPageMobile';

export default function TicketDetailPage() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return isMobile
    ? <TicketDetailPageMobile />
    : <TicketDetailPageDesktop />;
}